/**
 * Pure helpers for actor avatars used in notifications and live-activity badges.
 * No React imports — safe to use anywhere.
 */

const PALETTE = [
  { bg: 'bg-blue-100',   text: 'text-blue-700' },
  { bg: 'bg-violet-100', text: 'text-violet-700' },
  { bg: 'bg-teal-100',   text: 'text-teal-700' },
  { bg: 'bg-amber-100',  text: 'text-amber-800' },
  { bg: 'bg-rose-100',   text: 'text-rose-700' },
  { bg: 'bg-emerald-100', text: 'text-emerald-700' },
];

/**
 * Returns up to two-character initials from a display name.
 * - "Jane Doe" -> "JD"
 * - "alice"    -> "A"
 * - null/empty/whitespace -> "?"
 *
 * @param {string | null | undefined} name
 * @returns {string}
 */
export function getInitials(name) {
  if (name == null) return '?';
  const trimmed = String(name).trim();
  if (trimmed.length === 0) return '?';

  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

/**
 * Deterministic Tailwind bg/text color pair derived from a seed string.
 * Same seed always returns the same colors.
 *
 * @param {string | number | null | undefined} seed
 * @returns {{ bg: string, text: string }}
 */
export function getAvatarColors(seed) {
  const str = seed == null ? '' : String(seed);
  if (str.length === 0) return PALETTE[0];

  let sum = 0;
  for (let i = 0; i < str.length; i += 1) {
    sum += str.charCodeAt(i);
  }
  return PALETTE[sum % PALETTE.length];
}
